import { Tooltip, Typography } from "@mui/material";

const Device = ({ fontSize, device }) => {
  return (
    <Tooltip title={device}>
      <Typography noWrap {...{ fontSize, sx: { cursor: "default" } }}>
        {device}
      </Typography>
    </Tooltip>
  );
};

export default Device;
